import {PolymerElement} from '@polymer/polymer/polymer-element.js';
import {
  AdrService,
  ProductService,
  CartService,
  ShippingService,
  PickupUtil,
  Agelocme,
  AssessmentService
} from '@nuskin/ns-shop';
import {
  RunConfigService,
  dateFormatter,
  ConfigService,
  storage,
  UrlService,
  NsRestError,
  moment,
  ResourceNotFoundError,
  events,
  DowntimeService
} from '@nuskin/ns-util';
import { getPartialConfig } from '@nuskin/configuration-sdk';
import { Order } from '@nuskin/order-model';
import { AccountManager, UserService } from '@nuskin/ns-account';
import { NsLoyalty } from '@nuskin/ns-loyalty';
import {html} from '@polymer/polymer/lib/utils/html-tag.js';
// import {detailAdr} from './details-return-object.js';
import template from './ns-adp-wrapper.html';
import wrapperTestResponse from './wrapper-test-object.js';
import TranslationMixin from '../temp/ns-translations';
import _ from 'lodash';
import axios from 'axios';
/**
 * Image Imports
 */
import closeIcon from '../img/ic-close-small.svg';
import warningIcon from '../img/warning-icon.svg';
import infoIcon from '../img/info-icon-blue.svg';

import {getSandboxedFlagInstance} from '@nuskin/ns-feature-flags';

import { MarketHeaderService } from "@nuskin/ns-product";

/**
 * This is the ADP Manage Wrapper Component for the ADP Manage Page.
 * Component encompasses the following: ns-adp-product, ns-shipping, ns-billing,
 * ns-scan-card, and ns-order.
 *
 * <section>
 *  <h2>Content Guidelines</h2>
 *  <p>Adding the property "is-test" on the adp-wrapper will allow it to load with a mock object.</p>
 * </section>
 *
 * <h2>ADP Manage Component Demo</h2>
 * <demo-snippet class="demoSnippet">
 *   <template>
 *     <ns-adp-wrapper is-demo></ns-adp-wrapper>
 *   </template>
 * </demo-snippet>
 */
export class NsAdpWrapper extends TranslationMixin(PolymerElement) {
  static get is () {
    return 'ns-adp-wrapper';
  }

  static get template () {
    let htmlElement = document.createElement('TEMPLATE');
    htmlElement.innerHTML = template;
    return htmlElement;
  }

  static get properties () {
    return {
      /**
      * Value passed through from ns-dropdown
      */
      selected: {
        type: Number,
        notify: true,
        observer: '_dropDownChange'
      },
      /**
      * Stores the selectedAdr for any child components to grab from
      */
      selectedAdr: {
        type: Object,
        notify: true,
        observer: '_newSelected'
      },
      /**
      * Language used to find translations
      */
      language: {
        type: String
      },
      /**
      * Country used for service calls
      */
      country: {
        type: String
      },
      /**
      * Populates component with test data and prevents any unnecessary network calls.
      */
      isDemo: {
        type: Boolean
      },
      /**
       * Set point balance after it comes back from ADR Status call
       */
      pointsBalance: {
        type: String,
        observer: 'setPointsBalance'
      },
      /**
       * Encoded value of the close icon used for passing this value to the template
       */
      closeIcon: {
        type: String,
        value: closeIcon
      },
      /**
       * Encoded value of the warning icon used for passing this value to the template
       */
      warningIcon: {
        type: String,
        value: warningIcon
      },
      /**
       * Encoded value of info icon used for passing this value to the template
       */
      infoIcon: {
        type: String,
        value: infoIcon
      },
      /**
       * List of ADRs available
       */
      adrList: {
        notify: true
      },
      /**
       * AEM configuration setting to redirect to custom page instead of the home page when deleting the last ADR
       */
      adrDeleteRedirectToCustomPage: {
        type: Boolean
      },
      /**
       * AEM configuration, Markets that want to allow the user to delete their last ADR
       */
      allowDeleteLastAdr: {
        type: Boolean
      },
      /**
       * AEM configuration, If true throws an exception when delete is called on ADR
       */
      disableAdrDelete: {
        type: Boolean
      },
      /**
       * AEM configuration, display bimonthly frequency option for adr
       */
      displayBiMonthlyFrequency: {
        type: Boolean
      },
      /**
       * AEM configuration, Show the bimonthly popup on the adr manage page
       */
      displayBiMonthlyPopup: {
        type: Boolean
      },
      /**
       * AEM configuration, Show the wire/bank transfer checkbox on the ADR manage page
       */
      showWirePaymentCheckbox: {
        type: Boolean
      },
      /**
       * AEM configuration, determines whether or not we show a place for a coupon code on the Manage ADR for agelocme
       */
      usesAgelocMeCouponCodeAdr: {
        type: Boolean
      },
      /**
       * Allows disabling of delete buttons in the wrapper's sub-components,for testing purposes.
       * For now, this affects just Billing and Shipping.
       */
      enableDelete: {
        type: Boolean,
        value: false
      },
      /**
       * holder for the feature flags enabled for the user
       */
      featureFlags: {
        type: Object,
        value: {}
      },
      /**
      * Used to hide the modal overlay
      */
      hideOverlay: {
        type: Boolean,
        notify: true
      },
      /**
       * Property to toggle service call loader, ns-global-loader component
       */
      showLoader: {
        type: Boolean
      },
      /**
       * Property to show adp dropdown
       */
      showAdpDropdown: {
        type: Boolean,
        value: false
      },
      /** These properties are used to pass data between ns-adp-wrapper and its child components **/
      /**
       * Object used to share data between ns-scan-cards and ns-adp-wrapper.
       */
      scanCardsDataObject: {
        type: Object,
        notify: true
      },
      /**
       * Object used to share data between ns-billing and ns-adp-wrapper.
       */
      billingDataObject: {
        type: Object,
        notify: true
      },
      /**
       * Object used to share data between ns-shipping and ns-adp-wrapper.
       */
      shippingDataObject: {
        type: Object,
        notify: true
      },
      /**
       * Page upon which this component appears. Used for translations.
       */
      webPageName: {
        type: String,
        value: 'shop/adp-manage'
      },
      /**
       * Translations from the server. Triggers the translation assignment process.
       * If undefined and shouldAwaitTranslations=false, this component will fetch its own strings.
       */
      serverTranslations: {
        type: Object,
        observer: '_assignTranslations'
      },
      /**
       * If false, it will start the translation assignment process without waiting.
       * If true, it will wait for serverTranslations to be set before starting the translation assignment process.
       * If serverTranslations is defined already, the component will behave as if this property is true.
       */
      shouldAwaitTranslations: {
        type: Boolean,
        value: false
      },
      toastMessages: {
        type: Array,
        value: () => []
      },
      /**
       * Common Constants used across file
       */
      _CONSTANTS: {
        type: Object,
        value: {
          BAD_REQUEST_CODE: '400',
          INVALID_ADDRESS_EXCEPTION: 'noTaxJurisdiction',
          REFRESH_EXCEPTION: 'adrRefresh'
        }
      },
      isPaymentEditable: {
        type: Boolean,
        computed: '_computeIsPaymentEditable(isEditable, allowPaymentEdit)'
      },
      isShippingEditable: {
        type: Boolean,
        computed: '_computeIsShippingEditable(isEditable, allowShippingAddressEdit)'
      },
      /**
       * loyaltyConfig
       * Configuration for loyalty
       * */
      loyaltyConfig: {
        type: Object
      },
      dropdownEllipsis: {
        type: Boolean,
        value: false
      },
      dropdownAdrNumberLabel: {
        type: String,
        value: ''
      },
      adrDisabledDates: {
        type: Array,
        value: () => []
      },
      useCustomAgelocMeLabel: {
        type: Boolean,
        value: false
      }
    };
  }

  static get observers () {
    return [
      '_handleScanCardsAdrService(scanCardsDataObject.updateType)',
      '_handleBillingAdrService(billingDataObject.updateType)',
      '_handleShippingAdrService(shippingDataObject.updateType)',
      '_onToastMessagesChanged(toastMessages.splices)',
      '_displayScanCards(selectedAdr.scanCardsCount)'
    ];
  }

  constructor () {
    super();
    $('body').hide();
  }

  ready () {
    super.ready();

    this.AdrService = AdrService;
    this.ConfigService = ConfigService;
    this.ProductService = ProductService;

    if (AccountManager.isLoggedIn() === null && !this.isDemo) {
      events.publish(events.authentication.REQUEST_FOR_LOGIN);
    } else {
      $('body').show();
    }

    this._setConfigurations();

    this._checkDownTime()
    .catch(err => console.warn(err));

    this.adrList = [];

    this._closeOverlay();
    this.componentsArray = ['ns-billing', 'ns-shipping', 'ns-orders', 'ns-scan-cards-repeat'];
    this.filtersArray = this.showScanCardsComponent ? [] : ['ns-scan-cards-repeat'];
    this.closeOverlayArray = this.componentsArray.filter(component => !this.filtersArray.includes(component));
    events.subscribe(events.subscriptions.SUBSCRIPTION_LOYALTY_POINTS_UPDATED, adr => {
      this.selectedAdr = AdrService.mapAdrDetail(
        adr,
        this.adrList[this.selected]
      );
      this._handleProductData();
    })
  }

  /**
   * Webcomponent LifeCycle Event
   */
  connectedCallback () {
    super.connectedCallback();
    this._addEventListeners(this.closeOverlayArray);
  }

  /**
   * Webcomponent LifeCycle Event
   */
  disconnectedCallback () {
    super.disconnectedCallback();
    this._removeEventListeners(this.closeOverlayArray);
  }

  /**
   * Adds the 'closeAdpWrapperOverlay' event listeners
   * @param {*} componentNameArray - Array of component names
   */
  _addEventListeners (componentNameArray) {
    this._listenerCloseOverlay = evt => { this.hideOverlay = evt.detail.closeOverlay };
    this._listenerDeleteAdr = () => { this._onClickDeleteAdr() };

    componentNameArray.map(component => {
      const $component = this.shadowRoot.querySelector(component);
      if ($component) {
        $component.addEventListener('closeAdpWrapperOverlay', this._listenerCloseOverlay);
        $component.addEventListener('deleteAdr', this._listenerDeleteAdr);
      }
    });
  }

  /**
   * Removes the 'closeAdpWrapperOverlay' event listeners
   * @param {*} componentNameArray - Array of component names
   */

  _removeEventListeners (componentNameArray) {
    if (!this.isDemo) {
      componentNameArray.map(component => {
        const $component = this.shadowRoot.querySelector(component);
        if ($component) {
          $component.removeEventListener('closeAdpWrapperOverlay', this._listenerCloseOverlay);
          $component.removeEventListener('deleteAdr', this._listenerDeleteAdr);
        }
      });
    }
  }

  _initialize() {
    const hasAdrCartCommittedChange = sessionStorage.getItem('has-adr-cart-committed-change');
    sessionStorage.removeItem('has-adr-cart-committed-change');

    if (!this.isDemo) {
      this._showLoader();
      Promise.all([
        this._initShipMethodsConfig(),
        this._getAdrStatus(),
        this._initShipDaysInfo()
      ])
        .then(() => this._getListResponse())
        .then(() => {
          if (hasAdrCartCommittedChange) this._displayOperationSuccessMsg();
        })
        .finally(() => this._hideLoader())
        .catch(err => this._handleError(err));
      this._getFeatureFlags()
    } else {
      this._testResponse();
    }
  }

  /**
   * Sets configurations to customize functionality for the current market
   */
  _setConfigurations () {
    const RUN_CONFIG = RunConfigService.getRunConfig();
    const BASE_SERVICE = ConfigService.getMarketConfig();
    const SERVICE = BASE_SERVICE.adpManage;
    const DEFAULT = {
      'adrDeleteRedirectToCustomPage': false,
      'allowDeleteLastAdr': true,
      'disableAdrDelete': true,
      'displayBiMonthlyFrequency': false,
      'displayBiMonthlyPopup': false,
      'showWirePaymentCheckbox': false,
      'usesAgelocMeCouponCodeAdr': false,
      'showScanCardsComponent': false,
      'canDeleteAdr': false,
      'enablePayWithPoints': false,
      'allowShippingAddressEdit': true,
      'allowPaymentEdit': true,
      'preProcessingBlackoutHours': 0,
      'postProcessingBlackoutHours': 24,
      'useServerTranslationsForShipping': false,
      'agelocMeCustomLabelInEditManage': false
    };
    const CONFIG = Object.assign({}, DEFAULT, SERVICE);
    this.country = this.country || RUN_CONFIG.country;
    this.language = this.language || RUN_CONFIG.language;
    this.adrDeleteRedirectToCustomPage = CONFIG.adrDeleteRedirectToCustomPage;
    this.adrProgramName = CONFIG.adrProgram;
    this.allowDeleteLastAdr = CONFIG.allowDeleteLastAdr;
    this.disableAdrDelete = CONFIG.disableAdrDelete;
    this.displayBiMonthlyFrequency = CONFIG.displayBiMonthlyFrequency;
    this.displayBiMonthlyPopup = CONFIG.displayBiMonthlyPopup;
    this.showWirePaymentCheckbox = CONFIG.showWirePaymentCheckbox;
    this.usesAgelocMeCouponCodeAdr = CONFIG.usesAgelocMeCouponCodeAdr;
    this.showScanCardsComponent = CONFIG.showScanCardsComponent;
    this.showScanCardsInviteDialog = CONFIG.showScanCardsInviteDialog;
    this.canDeleteAdr = CONFIG.canDeleteAdr;
    this.enablePayWithPoints = CONFIG.enablePayWithPoints;
    this.useShippingCountryAdrPoints = CONFIG.useShippingCountryAdrPoints || false;
    this.adrPointsCountryOverride = CONFIG.adrPointsCountryOverride;
    this.disableAdrOverrides = CONFIG.disableAdrOverrides;
    this.allowUnlimitedOverrides = CONFIG.allowUnlimitedOverrides;
    this.disableOverrideDuringBlackout = CONFIG.disableOverrideDuringBlackout;
    this.allowUserHolds = CONFIG.allowUserHolds;
    this.allowShippingAddressEdit = CONFIG.allowShippingAddressEdit;
    this.allowPaymentEdit = CONFIG.allowPaymentEdit;
    this.preProcessingBlackoutHours = isNaN(CONFIG.preProcessingBlackoutHours)
      ? 0
      : Number.parseInt(CONFIG.preProcessingBlackoutHours);
    this.postProcessingBlackoutHours = isNaN(CONFIG.postProcessingBlackoutHours)
      ? 24
      : Number.parseInt(CONFIG.postProcessingBlackoutHours);

    this.set('loyaltyConfig', BASE_SERVICE.loyalty);
    this.useCustomAgelocMeLabel = CONFIG.agelocMeCustomLabelInEditManage;
  }


  /**
   * Observer for scanCardsCount
   * Display the scan card component if market config showScanCardsComponent is set to true and
   * scanCardsCount (number of scan qualified items) is greater than 0
   */
  _displayScanCards () {
    if (!this.selectedAdr) return;

    const scanCardsCount = (this.selectedAdr.Scan || []).length;
    const scanQualifiedCount = getScanQualifiedCount(this.selectedAdr.lineItems);

    const displayScanCards = this.showScanCardsComponent
      && (scanQualifiedCount > 0 || scanCardsCount > 0);
    this.set("displayScanCards", displayScanCards);
  }

  /**
   * Observer for if delete button should be hidden
   */
  hideDeleteButton (isEditable) {
    return !this.isEditable
      || !this.canDeleteAdr
      || (this.adrList.length === 1 && !this.allowDeleteLastAdr);
  }

  /**
   * Observer function for this.pointsBalance
   * Sets the Points Balance per user account when the service
   * returns with a ADR Status response
   */
  setPointsBalance () {
    this.productDataObject.pointsBalance = this.pointsBalance;
    this.set('productDataObject', this.productDataObject);
  }

  /**
   * Observer on serverTranslations that gathers all translations and maps them to properties.
   * Any strings set as properties and defined in the html attributes take precedence over translations from the server,
   * which in turn take precedence over the default translations in the translations file.
   */
  async _assignTranslations () {
    if (!this.serverTranslations) return;
    let allTranslations = Object.assign({}, this.serverTranslations);
    Object.entries(allTranslations).forEach(([key, value]) => this[key] = this[key] || value);
    this._initialize();
  }

  _testResponse () {
    this.adrList = wrapperTestResponse.wrapperTestResponse;
    this.isEditable = false;
    this.adrStatus = {};
    this.adrStatus.TotalPoints = 3234.00;
    this.showLoader = false;
    this.selectedAdr = wrapperTestResponse.wrapperTestResponse[0];
    this.selected = 0;
    this.isOverridable = false;
    this.isHoldable = false;
    this._handleShippingData();
    this._handleProductData();
    this._handleBillingData();
    this._handleScanCardsData();
    this._handleOrdersData();
    this._sendDataToSubComponents();
  }

  /**
   * GET adrList Call
   * Parses what is returned from the list request
   * makes a call for details on each ADR to populate local storage
   * @param {boolean} [forceRefresh = false] - flag to indicate to service whether it should
   *                                            return cached data when available
   */
  async _getListResponse (forceRefresh = false) {
    let listResponse = await AdrService.getAdrList({forceRefresh});

    // Check validity of ADR list
    if (!listResponse || listResponse.length === 0) {
      this._errorRedirect();
      return;
    }

    this.showAdpDropdown = true;

    // Map raw ADR list to data format needed by this app
    const mappedAdrs = listResponse.map(r => this._getSkusFromLineItems(r));

    // Apply product data to each ADR
    let adrPromises = mappedAdrs.map(adr => this._applyProductNames(adr));
    await Promise.all(adrPromises);

    this.adrList = mappedAdrs;
    const storedAdrId = storage.getItem(storage.metadata.ADR_CURRENT_ID);
    const selectedAdrIndex = this.adrList.findIndex((adr) => adr.key === storedAdrId);
    let index = selectedAdrIndex > 0 ? selectedAdrIndex : 0;
    this._setSelectedAdr(index);
  }

  async _initShipDaysInfo() {
    try {
      const { ShipDaysResponse } = await ShippingService.getShipDays();
      this.adrDisabledDates = ShipDaysResponse.blackoutDays;
    } catch (err) {
      console.warn(err);
    }
  }

  _getShipMehodsEnv() {
    switch (RunConfigService.getEnvironmentCode()) {
        case 'dev':
            return 'dev.';
        case 'test':
            return 'test.';
        case 'prod':
            return '';
        default:
            return 'test.';
    }
  }

  async _initShipMethodsData(detailResponse, dangerousGoods) {
    this.shipMethods = null;
    this.pickupPoints = null;

    if (this.useShipMethodsApi) {
      try {
        const order = Order.fromSalesOrderResponse(detailResponse);
        const env = this._getShipMehodsEnv();
        const response = await axios.post(
          `https://apis.${env}nuskin.com/ship-methods/v1`,
          {
            order,
            orderValue: order.orderTotals.grandTotal,
            dangerousGoods,
            language: this.language,
            country: this.country
          },
          {
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            }
          }
        )
        this.shipMethods = response.data.shipMethods;
        this.pickupPoints = response.data.pickupPoints;
      } catch (err) {
        console.log(err);
      }
    }
  }

  async _initShipMethodsConfig() {
    try {
      const response = await getPartialConfig({
        Checkout: ['useShipMethodsApi']
      });
      this.useShipMethodsApi = response.Checkout.useShipMethodsApi;
    } catch (err) {
      console.warn(err);
    }
  }

  /**
   * Retrieves product data for the given ADR and adds an adrName field to the ADR
   * object, which is generated from the product names
   * @param {Adr} adr - ADR object
   */
  async _applyProductNames(adr) {
    const AGELOCME_SKU = nuskin.configuration.agelocme.sku;

    // Retrieve product information
    let promises = adr.lineItems
      .map(item => /^[0-9]+$/.test(item.sku) ? item.sku : AGELOCME_SKU)
      .map(sku => ProductService.getProductData(sku))
      .map(promise => promise.catch(err => {
        // Fallback to null if product service throws an error,
        // to avoid crashing entire set of product queries
        console.error('ProductService error:', err);
        return null;
      }));
    let products = await Promise.all(promises);
    let scanCardsCount = 0; // holds the total number of scan cards allowed for the adr

    // Remove any fallback nulls from product list
    products = products.filter(p => p);

    let agelocMeProducts = products.filter(p => p.sku === AGELOCME_SKU)
    if (agelocMeProducts.length > 0 && !this.assessments) {
      await this._getAgelocMeAssessments();
    }
    // Apply product names to ADR line items
    adr.lineItems
      .filter(item => item.sku !== AGELOCME_SKU)
      .forEach(item => {
        const isNumericSku = /^[0-9]+$/.test(item.sku);
        let product = products.find(p => p.sku === item.sku || !isNumericSku && p.sku === AGELOCME_SKU);
        if (product && product.sku === AGELOCME_SKU) {
          this.assessments.filter(assessment => {
            return assessment.code == item.sku;
          }).map(match => {
            product.agelocme = new Agelocme({
              code: match.productCode || match.code,
              isCoreSolution: match.isCoreSolution,
              label: match.profileName || match.label,
              name: match.name
            });
          })
        }

        item.name = product ? product.title : item.sku

        let displayName;
        if (product && product.agelocme && this.useCustomAgelocMeLabel) {
          displayName = this._createAgelocCustomLabel(product)
        }
        item.displayName = displayName || item.name;

        if (!isNumericSku && this.useAgeLocItemName && !this.useCustomAgelocMeLabel) {
          /*
          This is done because the product name in AEM isn't sufficient for the ageloc pseudo-products.
          aem will have a product name like

          ageLoc me canister

          but the market wants a product name like

          ageLoc me canister ASD123

          which matches the full variant/pseudo-product code.
          These names do not exist in the web. They DO exist in the ADR detail call from SAP. However,
          that call is extremely expensive so we can't rely on using it,
          So we have to generate the name here in web.
          This WILL break if we have more products introduced with alphanumeric skus.
          It will also break if the product names for ageloc canisters undergo a major change,
          but it's the best that we can do in web right now to show these names.

          */
          item.name = item.name + ' ' + item.sku;
        }
        item.scanQualified = product ? product.scanQualified : 0;
        scanCardsCount += item.scanQualified * item.requestedQuantity;
        adr.dangerousGoods = adr.dangerousGoods || (product || {dangerousGoods: false}).dangerousGoods;
      });

    // Generate ADR name from product names
    adr.adrName = adr.lineItems.map(item => item.name).join(', ');
    adr.scanCardsCount = scanCardsCount;
  }

  /**
   * GET AdrStatus Call
   * Calls AdrService to return the AdrStatus for the logged in user
   * Upon successful response sets adrStatus property,
   * otherwise if an error is encountered during the fetch log and set points to 0
   * @param {boolean} [forceRefresh = false] - flag to indicate to service whether it should
   *                                            return cached data when available
   */
  async _getAdrStatus (forceRefresh = false) {
    if(this.enablePayWithPoints) {
      try {
        this.adrStatus = await AdrService.getAdrStatus({forceRefresh});
      } catch (err) {
        if (err instanceof ResourceNotFoundError) {
          this.adrStatus = { TotalPoints: 0 };
        } else {
          throw err;
        }
      }
    }
  }

  async _checkDownTime() {
    const downTimeResult = await DowntimeService.getDowntimeStatus();
    console.log(downTimeResult);
    if (downTimeResult.isDown) {
      CartService.goToCheckoutPage({route: 'downtime'});
    }
  }

  /**
   * Function that redirects to the adp error page
   */
  _errorRedirect () {
    let adpErrorPage;

    // Attempt to get path to error page from ADP Manage Page properties
    if (this.adpMissingErrorPagePath) {
      if (!/\.html$/.test(this.adpMissingErrorPagePath)) this.adpMissingErrorPagePath += '.html';
      adpErrorPage = this.adpMissingErrorPagePath;
    } else {
      adpErrorPage = `${RunConfigService.getBaseUrl()}/${RunConfigService.getRunConfig().language}_${RunConfigService.getRunConfig().country}/shop/adp-error.html`;
    }
    window.location = adpErrorPage;
  }

  /**
  * Helper method to correctly parse html entities coming back on strings from Product Service
  * @param {*} htmlString
  */
  _decodeHtml (htmlString) {
    let textArea = document.createElement('textarea');
    textArea.innerHTML = htmlString;
    return textArea.value;
  }

  /**
   * Handler called when the user clicks "Delete ADR".
   */
  _onClickDeleteAdr() {
    if (this.adrList.length === 1) {
      // One ADR remaining: show Last ADR Deletion confirmation modal
      this._openLastAdrDeletionDialog()
    } else {
      // Show ADR Deletion confirmation modal
      this._openDeletionDialog();
    }
  }

  /**
   * Handler called when the user confirms that they wish to delete the ADR.
   */
  _onClickConfirmDeleteAdr() {
    this._showLoader();
    this.deleteAdr()
      .then(() => {
        if (this.adrList.length === 0) {
          if (this.deletedLastAdrRedirectUrl && !/\.html$/.test(this.deletedLastAdrRedirectUrl)) this.deletedLastAdrRedirectUrl += '.html';
          let redirectUrl = this.deletedLastAdrRedirectUrl || `${UrlService.getLocaleUrl()}home.html`
          window.location = `${RunConfigService.getBaseUrl()}${redirectUrl}`;
        }
      })
      .finally(() => {
        this._closeDeletionDialog();
        this._closeLastAdrDeletionDialog();
        this._hideLoader();
      })
      .catch(err => {
        this._handleError(err);
      });
  }

  _openDeletionDialog() {
    this.shadowRoot.querySelector('#deletionDialog').open();
    this.hideOverlay = !this.hideOverlay;
    this._clearToastMessages();
  }

  _closeDeletionDialog() {
    this.shadowRoot.querySelector('#deletionDialog').close();
    this.hideOverlay = !this.hideOverlay;
    this._clearToastMessages();
  }

  _openLastAdrDeletionDialog() {
    this.shadowRoot.querySelector('#lastAdrDeletionDialog').open();
    this.hideOverlay = false;
    this._clearToastMessages();
  }

  _closeLastAdrDeletionDialog() {
    this.shadowRoot.querySelector('#lastAdrDeletionDialog').close();
    this.hideOverlay = true;
    this._clearToastMessages();
  }

  _closeOverlay () {
    this.hideOverlay = true;
  }

  _closeEditableDialog () {
    this.$.editableDialog.close();
    this._closeOverlay();
  }

  _openEditableDialog () {
    this.hideOverlay = false;
    this.$.editableDialog.open();
  }

  /**
  * Called on dropdown change
  * sets selected adr based on OrderID
  * Makes request to the list on 'this' to populate the required data
  */
  _dropDownChange (newValue, oldValue) {
    if (this.adrList && oldValue != null) {
      if (!this.isDemo) {
        this._showLoader();
      }
      if (this.selected > -1) {
        this._setSelectedAdr(this.selected)
          .finally(() => this._hideLoader())
          .catch(err => { this._handleError(err); });
      }
    }
    this._clearToastMessages();
  }
  /**
   * Returns an array of objects with an Adrs skus and corresponding quantities
   * @param {*} adr
   */
  _getSkusFromLineItems (adr) {
    let adrItem = {};
    adrItem['lineItems'] = [];
    adrItem['lineItemSkuListList'] = [];
    adrItem['key'] = adr.SalesOrderDetail.OrderID;
    adrItem['value'] = `ADR#${adr.SalesOrderDetail.OrderID}`;
    adr.SalesOrderDetail.LineItemDetails.filter(item => item.LineItem.ParentID === 0).map((item) => {
      adrItem['lineItems'].push({
        'sku': item.LineItem.SKU,
        'requestedQuantity': item.LineItem.RequestedQuantity,
        'grandFatheredPricing': item.GrandFatheredPricing
      });
      adrItem['lineItemSkuListList'].push(item.LineItem.SKU);
    });
    return adrItem;
  }

  /**
   * Cycles through the list to find the selected ADR
   * sets a boolean that checked if its the primary ADR
   * adds selectedAdr to localStorage
   * @param {number} [index] - adrList index
   * @param {boolean} [isToggleLoader] - flag to turn on/off loading screen
   * @param {boolean} [forceRefresh = false] - flag to indicate to service whether it should
   *                                            return cached data when available
   * @param {boolean} [fullAdrDetail = true] - flag to indicate to service whether it should
   *                                            use default behavior of cached data -
   * (return cached ADR from GET adrList call), or only return cached/fresh full ADR object from GET adrDetails call
   */
  async _setSelectedAdr (index, forceRefresh = false, fullAdrDetail = true) {
    if (this.isDemo) {
      // Bypass this function if in Demo/Edit mode
      return;
    }

    if (!this.adrList || this.adrList.length === 0) {
      // ADR List is empty. Redirect to Missing ADR Error Page.
      this._errorRedirect();
    } else if (this.adrList[index]) {
      this.showAdpDropdown = this.adrList.length > 1;
      this.detailResponse = await AdrService.getAdrDetails(this.adrList[index].key, {forceRefresh, fullAdrDetail});
      if (this.useShipMethodsApi) {
        await this._initShipMethodsData(this.detailResponse, this.adrList[index].dangerousGoods)
      }

      let mappedAdr = AdrService.mapAdrDetail(this.detailResponse, this.adrList[index]);

      this.selectedAdrProductDiscountCode = this.detailResponse.SalesOrderDetail.ProductDiscountCode;
      this.selectedAdrProductDiscount = this.detailResponse.SalesOrderDetail.LineItemDetails
        .map(d => d.ProductPromoSavings || 0)
        .reduce((acc, x) => acc + x, 0);

      this.selectedAdr = mappedAdr;
      this.selected = index;
      AdrService.saveAdrId(this.selectedAdr['key']);
      this._clearToastMessages();
      this._handleShippingData();
      this._handleProductData();
      this._handleBillingData();
      this._handleScanCardsData();
      this._handleOrdersData();
      this._sendDataToSubComponents();
    }
  }

  /**
   * Set flags indicating whether the ADR can be edited, overridden, or held.
   * UI elements are shown/hidden based on these flags.
   */
  _initEditOverrideHoldFlags() {
    /*
    Processing period of order begins at midnight, Nu Skin headquarters time,
    on the shipping date, as represented by the NextDeliveryDate timestamp.
    The ADR is in blackout (i.e. changes not allowed) for a period of time
    before the start of the processing period, as set by the market. It remains
    in blackout after the start of the processing period for another period of
    time also set by the market.

    The ADR is also locked from editing if the NextDeliveryDate timestamp falls
    in the past, indicating an ADR record that may be corrupted or otherwise
    not safe for user edits.
    */

    const now = new Date();
    const nextProcessDate = dateFormatter.toHQTimeStartOfDay(new Date(this.selectedAdr.NextDeliveryDate)).toDate();
    const processDateIsPast = nextProcessDate < now;

    const blackoutStartDate = new Date(nextProcessDate);
    blackoutStartDate.setHours(blackoutStartDate.getHours() - this.preProcessingBlackoutHours);

    const blackoutEndDate = new Date(nextProcessDate);
    blackoutEndDate.setHours(blackoutEndDate.getHours() + this.postProcessingBlackoutHours);

    const isInBlackout = (now > blackoutStartDate) && (now < blackoutEndDate);

    const isInAdrDisabledDates = this.adrDisabledDates.includes(now.getDate());

    this.isEditable = !isInBlackout && !processDateIsPast;

    // Open the 'in processing' modal if the ADR is not editable
    if (!this.isEditable) {
      this.hideOverlay = false;
      this._openEditableDialog();
    }

    /*
    If unlimited overrides are enabled, a user can override an ADR if it is
    editable. If unlimited overrides are not enabled, a user can override an
    ADR if it is editable, has NOT yet been overridden this month, and has NOT
    yet been processed this month.
    */
    if (this.disableAdrOverrides) {
      this.isOverridable = false;
    } else if (this.allowUnlimitedOverrides) {
      this.isOverridable = !!this.isEditable;
    } else {
      const orderPlacedThisMonth = (this.selectedAdr && this.selectedAdr.LastPlacedDate) ?
        new Date(this.selectedAdr.LastPlacedDate).getMonth() === new Date().getMonth() :
        false;
      this.isOverridable = !!this.isEditable && !(this.selectedAdr.overridden || orderPlacedThisMonth);
    }

    if (this.disableOverrideDuringBlackout && isInAdrDisabledDates) {
      this.isOverridable = false;
    }

    /*
    Determine time to next shipment, as defined from start of current month to
    date of next shipment. Shipment can be held if this time span is smaller
    than the order frequency plus one month.
    */
    const startOfCurrentMonth = moment();
    startOfCurrentMonth.startOf('month');
    const monthsToNextShipment = moment(new Date(this.selectedAdr.NextDeliveryDate)).diff(startOfCurrentMonth, 'month', true);
    const isWithinHoldableWindow = monthsToNextShipment < (this.selectedAdr.OrderFrequency + 1);

    this.isHoldable = this.allowUserHolds && this.isEditable && isWithinHoldableWindow;
  }

  /**
   * Updates data objects sent to subcomponents, also triggered by setSelectedAdr
   */
  _sendDataToSubComponents () {
    this.set('productDataObject', this.productDataObject);
    this.set('scanCardsDataObject', this.scanCardsDataObject);
    this.set('ordersDataObject', this.ordersDataObject);
  }

  /**
   * Decouples shipping data to a shippingDataObject
   */
  _handleShippingData () {
    const shipToAddress = this.selectedAdr.shipping.shipping.ShippingParty
      .find((object) => object['Type'] === 'SHIP_TO');
    const pickUpOptionSelectedObject = this.selectedAdr.shipping.shipping.ShippingParty
      .find((object) => object['Type'] === 'PICK_UP');

    // Set up selected pick up option object from adr response
    let pickUpOptionSelected;
    if (pickUpOptionSelectedObject) {
      pickUpOptionSelected = {
        name: pickUpOptionSelectedObject.ShippingAddress.Name,
        street: pickUpOptionSelectedObject.ShippingAddress.Address.Street1,
        city: pickUpOptionSelectedObject.ShippingAddress.Address.City,
        postalCode: pickUpOptionSelectedObject.ShippingAddress.Address.PostalCode
      }
    }
    let contactEntries = [];
    let currentShippingAddressName = '';
    let currentShippingAddress = {};
    let shippingId;
    if (shipToAddress) {
      contactEntries = shipToAddress.ShippingAddress.Contact || [];
      currentShippingAddressName = shipToAddress.ShippingAddress.Name;
      shippingId = shipToAddress.ShippingAddress.ID;
      currentShippingAddress = shipToAddress.ShippingAddress.Address;
    }

    const homePhone = contactEntries
      .filter((object) => object['Value']['Type'] === 'HOMEPHONE')
    const shipToPhone = homePhone.reduce((acc, el) => el['Value']['value'], '');
    const shipToPhoneCountry = homePhone.reduce((acc, el) => el['Country'], '');
    const mobilePhone = contactEntries
      .filter((object) => object['Value']['Type'] === 'MOBILEPHONE')
    const shipToMobilePhone = mobilePhone.reduce((acc, el) => el['Value']['value'], '');
    const shipToMobilePhoneCountry = mobilePhone.reduce((acc, el) => el['Country'], '');
    const shipToEmail = contactEntries
      .filter((object) => object['Value']['Type'] === 'EMAIL')
      .reduce((acc, el) => el['Value']['value'], '');

    this.set('shippingDataObject', {
      lastPlacedDate: this.selectedAdr.LastPlacedDate,
      nextDeliveryDate: this.selectedAdr.NextDeliveryDate,
      shippingId,
      shipToPhoneCountry,
      shipToPhone,
      shipToMobilePhoneCountry,
      shipToMobilePhone,
      shipToEmail,
      frequency: this.selectedAdr.OrderFrequency,
      currentShippingAddressName,
      shipping: this.selectedAdr.shipping,
      currentShippingAddress,
      shippingAvailableMethods: this.shipMethods || this.selectedAdr.shipping.shippingMethods,
      shippingMethodDetails: this.selectedAdr.shipping.ShippingMethod,
      timeStamp: this.selectedAdr.TimeStamp,
      orderId: this.selectedAdr.key,
      pickUpOptions: this.pickupPoints || this.pickUpOptions,
      pickUpOptionSelected: pickUpOptionSelected
    });
    // this.pickupPoints = null;
  }

  /**
   * Observer for shippingDataObject.updateType
   * Makes an edit call to the ADR service with data from ns-shipping
   * @param {String} [shippingDataObject.updateType] - shipping component will set shippingDataObject.updateType
   *                                                    to 'Update' when it wants to update ADR shipping
   * @param {boolean} [forceRefresh = false] - flag to indicate to service whether it should return cached
   *                                            data when available
   */
  _handleShippingAdrService (updateType) {
    if (this.shippingDataObject.updateType === 'Update') {
      this.addressListError = null;

      this._showLoader();

      // PUT - ADR with updated Shipping, retry on adrRefresh error requesting forceRefresh
      // Error is caught on this level and not in _setAdrShippingAddress() - see method comment block
      this._setAdrShippingAddress(
        this.shippingDataObject.orderId, this.shippingDataObject.body, this.shippingDataObject.options, true
      ).catch(err => {
          if (this._isErrorNoTaxJurisdiction(err)) {
            this.addressListError = this.invalidAddressError;
            this._handleError(err);
          } else if (this._isErrorAdrRefresh(err)) {
            // retry call one more time with forceRefresh
            return this._setAdrShippingAddress(
              this.shippingDataObject.orderId, this.shippingDataObject.body, this.shippingDataObject.options, true
            );
          } else {
            this._handleError(err);
          }
        })
        .finally(() => this._hideLoader())

        // Catch block for error thrown by this._setAdrShippingAddress()
        .catch(err => this._handleError(err));
    }
  }

  /**
   * PUT call to update ADR shipping
   * Errors returned from service are caught by the implementation of this method - see _handleShippingAdrService()
   * This is done so that the retry would only fire once in case the data is in a bad state returned
   * for GET adrDetails from Server
   * @param {String} [orderId] - ADR Id
   * @param {Object} [shippingDataBody] - shippingDataObject.body - shipping to update
   * @param {Object} [shippingDataOptions] - shippingDataObject.options - options passed into service
   * @param {boolean} [forceRefresh = false] - flag to indicate to service whether it should return cached
   * data when available
   */
  async _setAdrShippingAddress (orderId, shippingDataBody, shippingDataOptions) {
    if (shippingDataOptions.Simulate) {
      if (!this.useShipMethodsApi) {
        return AdrService.setAdrShippingAddress(orderId, shippingDataBody, shippingDataOptions)
        .then((response) => {
          this.pickUpOptions = PickupUtil.parse(response.SalesOrderDetail.Custom || []);
          this.set('shippingDataObject.pickUpOptions', this.pickUpOptions);
        })
        .finally(() => {
          this.set('shippingDataObject.updateType', null);
        });
      } else {
        if (!this.shippingDataObject.pickUpOptions) {
          const shipTo = this.detailResponse.SalesOrderDetail.Shipping.ShippingParty
            .find((sp) => sp.Type === 'SHIP_TO');
          Object.assign(shipTo.ShippingAddress.Address, shippingDataBody.Address);
          const dangerousGoods = this.adrList.find((adr) => adr.key === orderId).dangerousGoods;
          await this._initShipMethodsData(this.detailResponse, dangerousGoods);
          this.set('shippingDataObject.pickUpOptions', this.pickupPoints);
        } else {
          this.set('shippingDataObject.pickUpOptions', [].concat(this.shippingDataObject.pickUpOptions));
        }
        this.pickupPoints = null;
        this.set('shippingDataObject.updateType', null);
      }
    } else {
      return AdrService.setAdrShippingAddress(orderId, shippingDataBody, shippingDataOptions)
        .then(() => AdrService.getAdrDetails(orderId, {forceRefresh: true}))
        .then(async adr => {
          this.detailResponse = adr;
          const selectedAdrIndex = this.adrList.findIndex((adrl) => adrl.key === adr.SalesOrderDetail.OrderID);
          let index = selectedAdrIndex > 0 ? selectedAdrIndex : 0;
          if (this.useShipMethodsApi) {
            await this._initShipMethodsData(this.detailResponse, this.adrList[index].dangerousGoods)
          }
          const requestedMethodCode = shippingDataOptions.ShippingMethod;
          const availableMethods = this.shipMethods || adr.SalesOrderDetail.ShippingAvailableMethods;

          if (!availableMethods.some(method => method.Code === requestedMethodCode)) {
            const defaultMethod = availableMethods
              .reduce((acc, el) => el.Default ? el : acc, availableMethods[0]);

            await AdrService.setAdrShippingAddress(orderId, shippingDataBody, {
              ...shippingDataOptions,
              ShippingMethod: defaultMethod.Code
            });

            const updatedAdr = await AdrService.getAdrDetails(orderId, {forceRefresh: true});

            this._openShippingMethodResetDialog();

            return updatedAdr;
          }

          return adr;
        })
        .then(adr => {
          let shippingMethod = this.shippingDataObject.options.ShippingMethod ||
                                this.shippingDataObject.shipping.shipping.ShippingMethod.Code;
          let pickUpLocation;
          // Only assign pick up location if shipping method is pick up.
          if ((shippingMethod === 'PU' || shippingMethod === 'M3') && !pickUpLocation) {
            pickUpLocation = this.shippingDataObject.options.PickUpLocation ||
                              this.shippingDataObject.shipping.shipping.ShippingMethod.PickUpLocation;
          }
          this.selectedAdr = AdrService.mapAdrDetail(
            adr,
            this.adrList[this.selected],
            this.shippingMethods || this.shippingDataObject.shippingAvailableMethods,
            shippingMethod,
            pickUpLocation
          );
          this._handleShippingData();
          this._handleOrdersData();
          this._handleProductData();
          this._displayOperationSuccessMsg();
        })
        .finally(() => {
          this.set('shippingDataObject.updateType', null);
          if (this.useShipMethodsApi) {
            this.set('shippingDataObject.pickUpOptions', this.pickupPoints);
            this.pickupPoints = null;
          }
      });
    }
  }

  /**
   * Returns boolean based on invalid address error - (400 Status, and Error='noTaxJurisdiction')
   * @param {String} [err] - Error thrown from AdrService.transformFetchResponse()
   * @return {boolean} isErrorNoTaxJurisdiction - flag indicates invalid address
   */
  _isErrorNoTaxJurisdiction (err) {
    return err.message.includes(this._CONSTANTS.BAD_REQUEST_CODE) &&
      err.message.includes(this._CONSTANTS.INVALID_ADDRESS_EXCEPTION);
  }

  /**
   * Returns boolean based on stale ADR data. ADR orders are timestamped for
   * versioning - (400 Status, and Error='adrRefresh')
   * @param {String} [err] Error thrown from AdrService.transformFetchResponse()
   * @return {boolean} isErrorAdrRefresh - flag indicates incorrect version of ADR
   */
  _isErrorAdrRefresh (err) {
    return err.message.includes(this._CONSTANTS.BAD_REQUEST_CODE) &&
      err.message.includes(this._CONSTANTS.REFRESH_EXCEPTION);
  }

  /**
   * Decouples Product data to a productDataObject
   */
  _handleProductData () {
    // Find shipping party object of the shipping address
    const shippingParty = this.selectedAdr.shipping.shipping.ShippingParty
      .find((object) => object['Type'] === 'SHIP_TO');

    // Get country code of the shipping address
    const shippingCountry =
      this.adrPointsCountryOverride ||
      (shippingParty
        ? shippingParty.ShippingAddress.Address.CountryCode
        : this.country
      );

    const useShippingCountry =
      this.useShippingCountryAdrPoints ||
      !!this.adrPointsCountryOverride;

    if (this.enablePayWithPoints) {
      // If pay-with-points is enabled, get applicable points balance
      AdrService.getMarketAdrPointsData({
        shippingCountry,
        useShippingCountry
      }).then((pointsData) => {

        this.set('productDataObject', {
          shippingTotal: this.selectedAdr.shippingTotal,
          shipping: this.selectedAdr.shipping.shipping.ShippingMethod ? this.selectedAdr.shipping.shipping.ShippingMethod.Cost : 0,
          psv: this.selectedAdr.psvBalance,
          tax: this.selectedAdr.tax,
          grandTotal: this.selectedAdr.total,
          itemSubTotal: this.selectedAdr.subTotal,
          products: this.selectedAdr.products,
          oneTimeProducts: this.selectedAdr.oneTimeProducts,
          pointsBalance: pointsData ? pointsData.AvailablePoints : undefined,
          expiringPoints: pointsData ? pointsData.ExpiringPoints : undefined,
          updateType: 'none',
          giftReceipt: this.selectedAdr.giftReceipt
        });
      })
    } else {
      this.productDataObject = {
        shippingTotal: this.selectedAdr.shippingTotal,
        shipping: this.selectedAdr.shipping.shipping.ShippingMethod ? this.selectedAdr.shipping.shipping.ShippingMethod.Cost : 0,
        psv: this.selectedAdr.psvBalance,
        tax: this.selectedAdr.tax,
        grandTotal: this.selectedAdr.total,
        itemSubTotal: this.selectedAdr.subTotal,
        products: this.selectedAdr.products,
        oneTimeProducts: this.selectedAdr.oneTimeProducts,
        pointsBalance: null,
        updateType: 'none',
        giftReceipt: this.selectedAdr.giftReceipt
      };
    }

  }

  /**
   * Decouples Billing data to a billingDataObject
   * Uses selectedAdr to pass data to billing through billingDataObject
   */
  _handleBillingData () {
    this.billingDataObject = {
      countryCode: this.country,
      shipToCountryCode: this.selectedAdr.countryCode,
      payment: this.selectedAdr.payment,
      orderId: this.selectedAdr.key,
      timeStamp: this.selectedAdr.TimeStamp,
      nextDeliveryDate: this.selectedAdr.NextDeliveryDate,
      Editable: this.isEditable && this.allowPaymentEdit
    };
  }

  /**
   * Observer for billingDataObject.updateType
   * Makes an edit call to the ADR service with data from ns-billing
   * @param {String} [billingDataObject.updateType] - billing component will set billingDataObject.updateType to 'Update' when it wants to update ADR billing
   * @param {boolean} [forceRefresh = false] - flag to indicate to service whether it should return cached data when available
   */
  _handleBillingAdrService (updateType, forceRefresh = false) {
    if (this.billingDataObject.updateType === 'Update') {

      this._showLoader();

      // PUT ADR with updated Payment, retry on adrRefresh error requesting forceRefresh
      // Error is caught on this level and not in _editAdrPayments() - see method comment block
      this._editAdrPayments(this.billingDataObject.orderId, this.billingDataObject.body, forceRefresh)
        .catch(err => {
          if (this._isErrorAdrRefresh(err)) {
            // retry call one more time with forceRefresh
            return this._editAdrPayments(this.billingDataObject.orderId, this.billingDataObject.body, true);
          } else {
            this.editBillingErrorMessage = err.message;
            this._handleError(err);
          }
        })
        .finally(() => this._hideLoader())

        // Catch block for handling error thrown by this._editAdrPayments()
        .catch(err => this._handleError(err));
    }
  }

  /**
   * PUT call to update ADR billing
   * Errors returned from service are caught by the implementation of this method - see _handleBillingAdrService()
   * This is done so that the retry would only fire once in case the data is in a bad state returned for GET adrDetails from Server
   * @param {String} orderId - ADR Id
   * @param {Object[]} [billingDataBody] billingDataObject.body - array of payment data objects to edit
   * @param {boolean} [forceRefresh = false] - flag to indicate to service whether it should return cached data when available
   */
  async _editAdrPayments (orderId, billingDataBody, forceRefresh = false) {

    return AdrService.editAdrPayments(orderId, billingDataBody, {forceRefresh})
      .then(adr => {
        this.selectedAdr = AdrService.mapAdrDetail(adr, this.adrList[this.selected]);
        this._handleBillingData();
        const billingComponent = this.shadowRoot.querySelector('ns-billing');
        billingComponent.viewSelectedPaymentMethod();
        billingComponent.shadowRoot.querySelector('edit-billing-error-tag').scrollIntoView();
        this._displayOperationSuccessMsg();
      })
      .finally(() => {
        this.billingDataObject.updateType = 'none';
      });
  }

  /**
   * Decouples Scan Cards data to a scanCardsDataObject
   */
  _handleScanCardsData () {
    this.scanCardsDataObject = {
      scanCards: this.selectedAdr.Scan,
      timeStamp: this.selectedAdr.TimeStamp,
      adrnumber: this.selectedAdr.key,
      lineItemDetails: this.selectedAdr.lineItems,
      updateType: '',
      lineItemSkuList: this.selectedAdr.lineItemSkuList,
      scanCardsCount: this.selectedAdr.scanCardsCount
    };

    const scanQualifiedCount = getScanQualifiedCount(this.selectedAdr.lineItems);


    const scanCount = (this.selectedAdr.Scan || []).length;
    if (scanCount > scanQualifiedCount) {
      this._openScanCardOvercountDialog();
    }

    if (this.showScanCardsInviteDialog) {
      // Get SKUs of items added to most recently updated ADR
      const adrNewItemsStr = sessionStorage.getItem('adr-new-items');
      sessionStorage.removeItem('adr-new-items');
      const adrNewItems = JSON.parse(adrNewItemsStr || '{}');

      // If this ADR was the one most recently updated and if scan cards can be added...
      if (adrNewItems.adrId === this.selectedAdr.key
        && scanCount < scanQualifiedCount) {
        // ... and if one or more of those added items is scan-qualified...
        const hasNewScanQualified = this.selectedAdr.lineItems
          .filter(item => adrNewItems.skus.includes(item.sku))
          .some(item => item.scanQualified);

        // ... trigger popup to invite the user to add a scan card
        if (hasNewScanQualified) this._openScanCardAvailableDialog();
      }
    }
  }

  /**
   * Makes an edit call to the ADR service with data from ns-scan-cards
   */
  _handleScanCardsAdrService (options) {
    this._showLoader();
    switch (this.scanCardsDataObject.updateType) {
      case 'Update':
        AdrService.editAdrScanCards(
          this.scanCardsDataObject.adrnumber,
          AdrService.buildUpdateScanCardsList(this.scanCardsDataObject.scanCardsToUpdate),
          options)
          .then(() => AdrService.getAdrDetails(this.scanCardsDataObject.adrnumber))
          .then((adr) => {
            this._handleScanCardsUpdateResponse(adr, this.isToggleLoader);
            let newScanCards;
            /**
             * If we're changing the name of an existing scan card, whether or not we're also adding a new scan card,
             * the network call will respond with an array containing all the scan cards. If we're only adding a new
             * scan card or cards, the network call response will have an array containing only the added cards, so we
             * need to push those onto the old array.
             */
            if (this.currentScanCardChangeType === 'Add new scan card') {
              newScanCards = this.oldScanCards || [];
              for (let i = 0; i < adr.Scan.length; ++i) {
                newScanCards.push(adr.Scan[i]);
              }
            } else {
              newScanCards = adr.Scan;
            }
            this.scanCardsDataObject = {
              scanCards: newScanCards,
              timeStamp: adr.TimeStamp,
              adrnumber: adr.SalesOrderDetail.OrderID,
              lineItemDetails: adr.SalesOrderDetail.LineItemDetails,
              updateType: '',
              lineItemSkuList: this.selectedAdr.lineItemSkuList
            };

            this._displayOperationSuccessMsg();
          })
          .finally(() => this._hideLoader())
          .catch((err) => {
            if (this._isErrorAdrRefresh(err)) {
              this._handleScanCardsAdrService({forceRefresh: true, fullAdrDetail: true});
            } else {
              this.shadowRoot.querySelector('ns-scan-cards-repeat').handleUpdateError(err);
              this._handleError(err);
            }
          });
        break;
      case 'Deactivate':
        AdrService.editAdrScanCards(
          this.scanCardsDataObject.adrnumber,
          this.scanCardsDataObject.scanCards,
          options)
          .then(() => AdrService.getAdrDetails(this.scanCardsDataObject.adrnumber))
          .then((adr) => {
            const scan = adr.Scan;
            this.shadowRoot.querySelector('ns-scan-cards-repeat').handleDeactivateResponse(scan);
            this.scanCardsDataObject = {
              scanCards: adr.Scan,
              timeStamp: adr.TimeStamp,
              adrnumber: adr.SalesOrderDetail.OrderID,
              lineItemDetails: adr.SalesOrderDetail.LineItemDetails,
              updateType: '',
              lineItemSkuList: this.selectedAdr.lineItemSkuList
            };

            this._displayOperationSuccessMsg();
          })
          .finally(() => this._hideLoader())
          .catch((err) => {
            if (this._isErrorAdrRefresh(err)) {
              this._handleScanCardsAdrService({forceRefresh: true, fullAdrDetail: true});
            } else {
              this.shadowRoot.querySelector('ns-scan-cards-repeat').handleDeactivateError(err);
              this._handleError(err);
            }
          });
        break;
      default:
        this._hideLoader();
    }
  }

  /**
   * PUT response handler of "update scan cards" request
   *
   * params {*} response: response data
   */
  _handleScanCardsUpdateResponse (adr) {
    this.inEdit = false;
    const scanCards = adr.Scan;
    this.scanCardsDataObject.scanCards = scanCards;
    this.shadowRoot.querySelector('ns-scan-cards-repeat').stripEmptyScanCardsData();
    if (scanCards !== undefined && scanCards != null) {
      for (let i = 0; i < scanCards.length; i++) {
        const scanCardRow = {};
        scanCardRow.cardNumber = scanCards[i].ScanNumber;
        scanCardRow.cardName = scanCards[i].Label;
        let cardExists = false;
        for (let j = 0; j < this.shadowRoot.querySelector('ns-scan-cards-repeat').data.length; j++) {
          if (scanCardRow.cardNumber === this.shadowRoot.querySelector('ns-scan-cards-repeat').data[j].ScanNumber) {
            this.shadowRoot.querySelector('ns-scan-cards-repeat').data[j].Label = scanCardRow.cardName;
            cardExists = true;
            break;
          }
        }
        if (!cardExists) {
          this.shadowRoot.querySelector('ns-scan-cards-repeat').data.push(scanCardRow);
        }
      }
    }
    this.shadowRoot.querySelector('ns-scan-cards-repeat').appendEmptyScanCardsData();
  }

  /**
   * Decouples Order Delivery Dates data to a ordersDataObject
   */
  _handleOrdersData () {
    this.ordersDataObject = {
      lastPlacedDate: this.selectedAdr.LastPlacedDate,
      nextDeliveryDate: this.selectedAdr.NextDeliveryDate,
      orderId: this.selectedAdr.key,
      lineItems: this.selectedAdr.lineItems,
      monthCount: this.selectedAdr.monthCount
    };
  }

  /**
  * Reassigns the passed in selectedAdr from the service callbacks
  */
  _newSelected () {
    if (this.selectedAdr) {
      this._initEditOverrideHoldFlags();
      this.selectedAdrGrandfathered = (
        !!this.selectedAdr.lineItems.find((item) => item.GrandFatheredPricing)
      );
    }
  }

  /**
  * Deletes the currently selected ADR.
  * Once the ADR is deleted, the first ADR in the remaining list is selected.
  * @returns {Promise<void>}
  */
  deleteAdr () {
    return AdrService.deleteAdr(this.selectedAdr.key)
      .then(() => {
        // Remove deleted ADR from list
        this.splice('adrList', this.selected, 1);

        // Select the first remaining ADR
        return this._setSelectedAdr(0);
      });
  }

  /**
  * Opens print window
  */
  printWindow () {
    window.print();
    this._clearToastMessages();
  }

  _showLoader() {
    this.set('showLoader', true);
  }

  _hideLoader() {
    this.set('showLoader', false);
  }

  /**
   * Watches for scan-cards-changed events. This allows ns-scan-cards to let the wrapper know what kind of
   * change is being made (add new or edit existing).
   * @param {object} e the scan-cards-changed event
   */
  _handleScanCardsChange (e) {
    this.currentScanCardChangeType = e.detail.changeType;
    if (e.detail.changeType === 'Add new scan card') {
      this.oldScanCards = this.scanCardsDataObject.scanCards;
    }
  }

  /**
   * Adds a toast message for display to the user.
   * @param {string} type - message type: "success", "warning", "error", "information"
   * @param {Object} options - options:
   * @param {string} [options.header] - message header text
   * @param {string} [options.message] - message body text
   * @param {boolean} [options.scrollIntoView = false] - flag indicating whether to scroll to the toast message
   * @param {boolean} [options.showPrintOption = false] - flag indicating whether to show a print button
   */
  _addToastMessage(type, options = {}) {
    const MESSAGE_DEFAULTS = {
      type: 'information',
      header: '',
      scrollIntoView: false,
      showPrintOption: false
    };
    const messageObject = Object.assign({}, MESSAGE_DEFAULTS, options, {type});
    this.push('toastMessages', messageObject);
  }

  /**
   * Clears all toast messages from the page.
   */
  _clearToastMessages() {
    this.set('toastMessages', []);
  }

  /**
   * Observer to changes in the toast messages collection.
   * This observer triggers scrolling to the toast messages section if a
   * toast message is added with the `scrollIntoView` flag set.
   * @param {*} changeRecord - change record of the mutations performed on the observed array.
   */
  _onToastMessagesChanged(changeRecord) {
    if (!changeRecord) return;

    /*
    Scrolling the page to the toast messages section should only be triggered if
    one or more toast messages have been added to the collection, and one or more
    of those added messages have the scrollIntoView flag enabled.
    */
    const shouldScrollToToasts = changeRecord.indexSplices.some(iSplice => {
      return iSplice.object
        .slice(iSplice.index, iSplice.index + iSplice.addedCount)
        .some(toast => toast.scrollIntoView);
    });

    if (shouldScrollToToasts) {
      this.shadowRoot.querySelector('#toastMessages').scrollIntoView({behavior: 'smooth'});
    }
  }

  _handleError (err) {
    if (err instanceof NsRestError) {
      err.messages.forEach(m => {
        console.error(m.technicalMessage, m);
        this._addToastMessage('error', {
          header: m.message,
          scrollIntoView: true
        });
      });
    } else {
      console.error(err);
      this._addToastMessage('error', {
        header: err.message,
        scrollIntoView: true
      });
    }
    this._hideLoader();
  }

  _computeIsPaymentEditable(isEditable, allowPaymentEdit) {
    return isEditable && allowPaymentEdit;
  }

  _computeIsShippingEditable(isEditable, allowShippingAddressEdit) {
    return isEditable && allowShippingAddressEdit;
  }

  _openShippingMethodResetDialog() {
    this.dispatchEvent(new CustomEvent('closeAdpWrapperOverlay', {detail: {closeOverlay: false}}));
    this.$.shippingMethodResetDialog.open();
  }

  _closeShippingMethodResetDialog() {
    this.dispatchEvent(new CustomEvent('closeAdpWrapperOverlay', {detail: {closeOverlay: true}}));
    this.$.shippingMethodResetDialog.close();
  }

  _openScanCardOvercountDialog() {
    this.dispatchEvent(new CustomEvent('closeAdpWrapperOverlay', {detail: {closeOverlay: false}}));
    this.$.scanCardOvercountDialog.open();
  }

  _closeScanCardOvercountDialog() {
    this.dispatchEvent(new CustomEvent('closeAdpWrapperOverlay', {detail: {closeOverlay: true}}));
    this.$.scanCardOvercountDialog.close();
    this._scrollToScanCardsSection();
  }

  _openScanCardAvailableDialog() {
    this.dispatchEvent(new CustomEvent('closeAdpWrapperOverlay', {detail: {closeOverlay: false}}));
    this.$.scanCardAvailableDialog.open();
  }

  _closeScanCardAvailableDialog() {
    this.dispatchEvent(new CustomEvent('closeAdpWrapperOverlay', {detail: {closeOverlay: true}}));
    this.$.scanCardAvailableDialog.close();
  }

  _onClickManageScanCards() {
    this.dispatchEvent(new CustomEvent('closeAdpWrapperOverlay', {detail: {closeOverlay: true}}));
    this.$.scanCardAvailableDialog.close();
    this._scrollToScanCardsSection();

    setTimeout(() => {
      const $el = this.shadowRoot.querySelector('#ns-scan-cards-repeat');
      if ($el) $el._addButtonClicked();
    });
  }

  _scrollToScanCardsSection() {
    const $s = this.shadowRoot.querySelector("ns-scan-cards-repeat");
    if ($s) $s.scrollIntoView({ behavior: 'smooth' });
  }

  async _getFeatureFlags() {
    let userId;
    if (UserService.isLoggedIn()) {
      userId = UserService.getUser().id;
    }
    const flagService = getSandboxedFlagInstance()
    const flags = await flagService.retrieveProductionToggles(userId);
    this.featureFlags = Array.from(flags).reduce((a, x) => Object.assign(a, {[x]: true}), {});
  }

  computeDropdownPrefix(dropdownPrefix, index) {
    if (!dropdownPrefix) { return; }
    if (dropdownPrefix.includes('#')) {
      return dropdownPrefix.replace('#', index + 1);
    }
    return dropdownPrefix;
  }

  _computeDropdownItem(name, dropdownAdrNumberLabel, index) {
    if (!dropdownAdrNumberLabel) { return name; }
    const computedPrefix = this.computeDropdownPrefix(dropdownAdrNumberLabel, index);
    return `${computedPrefix} ${name}`;
  }

  _displayPrefix(dropdownPrefix) {
    return !!dropdownPrefix;
  }

  _displayOperationSuccessMsg() {
    this._clearToastMessages();

    /*
    Display success message after a minimal delay. This is done to prevent an
    event race condition with the previous action that clears the toast message
    list.
    */
    setTimeout(() => {
      this._addToastMessage('success', {
        header: this.actionSuccessLabel,
        scrollIntoView: true,
        showPrintOption: true
      });
    }, 1);
  }

  async _getAgelocMeAssessments() {
    let _this = this;

    let runConfig = RunConfigService.getRunConfig();
    const localeCode = `${runConfig.language || "en"}_${runConfig.country || "US"}`;

    const siteUrl = window.location.origin.startsWith("http://localhost")
      ? runConfig.baseUrl || "https://test.nuskin.com"
      : window.location.origin;

    const serviceData = await MarketHeaderService.getMarketHeaderData(
      `/content/nuskin/${localeCode}/home.html`,
      siteUrl,
      false,
      "searchbar"
    );

    let _getAssessments = AssessmentService.getAssessmentsV2;

    await _getAssessments(
      function success(data) {
        if (data.assessments) {
          _this.assessments = data.assessments;
        }
        _this.assessmentsLoading = false;
      },
      function failed(data) {}
    );
  }

  _createAgelocCustomLabel(product) {
    const defaultString = '{ title } { code } <br/> { label }';
    let label = this.agelocMeCustomLabel || defaultString
    return label.replace(/{ title }/, product.title)
          .replace(/{ label }/, product.agelocme.label)
          .replace(/{ code }/, product.agelocme.code);
  }
}

customElements.define(NsAdpWrapper.is, NsAdpWrapper);

function getScanQualifiedCount(lineItemDetails) {
  return lineItemDetails
    .filter(item => item.scanQualified)
    .map(item => item.scanQualified * item.requestedQuantity)
    .reduce((acc, el) => acc + el, 0);
}
